import React from 'react';
import styles from './privacyPolicyConfirmationView.module.scss';
import cx from 'classnames';
import { localizedStrings } from 'src/localization/index.jsx';
import Button from 'src/components/button';


class PrivacyPolicyConfirmationView extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            consentRequired : false
        }

        this._handlUpdateClick = this._handlUpdateClick.bind(this);
        this._handleCancelClick = this._handleCancelClick.bind(this);

        this.localizedCommons = localizedStrings.commons;
        this.localizedCommonActions = this.localizedCommons.actions;
        this.localizedSettings = localizedStrings.pages.settings;
        this.localizedPrivaryPolicy = this.localizedSettings.account.privacy_policy;
    }


    _handlUpdateClick() {
        this.props.updatePrivacyPolicyControl({privacyPolicyData: this.props.privacyPolicyData, consentRequired: this.state.consentRequired})
    }

    _handleCancelClick() {
        this.props.onCancel();
    }

    _handleChange(){
        this.setState({
            consentRequired: !this.state.consentRequired
        })
    }

    render() {
        return (    
            <div className={ styles.content }>
                
                <h1>{this.localizedPrivaryPolicy.title}</h1>

                <p>{this.localizedPrivaryPolicy.confirmation.sub_text}</p>
                <div className={styles.accessLevel}>
                    <i className={cx(this.state.consentRequired ? 'paperflite-tick-selected' : 'paperflite-radio-button-unselected')} aria-hidden="true" onClick={this._handleChange.bind(this)}></i>
                    <span className = {styles.options}>{this.localizedPrivaryPolicy.confirmation.option}</span>
                </div>
                <div className = {styles.bottomtext}>{this.localizedPrivaryPolicy.confirmation.bottom_text}</div>
                <div className={styles.buttonTray}>
                    <Button
                      icon="paperflite-tick"
                      variant="primary"
                      text={this.props.updating ? `${this.localizedCommonActions.confirming}` : this.localizedCommonActions.confirm}
                      disabled={this.props.updating}
                      className={styles.send}
                      onClick={() => {this._handlUpdateClick()}}
                    >
                    </Button>
                    <Button 
                      text={this.localizedCommonActions.cancel}
                      disabled={this.props.updating}
                      className={styles.cancel} 
                      onClick={() => {this._handleCancelClick()}}>
                    </Button> 
                </div>      
            </div>
        )
    }
}

export default  PrivacyPolicyConfirmationView;